// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"b7855ed1","81":"4e90882e","84":"63d013a4","122":"44b4c3f1","304":"d305ab28","336":"6872a28f","467":"8479b01f","580":"96babfa5","633":"32503518","892":"565f548c","981":"f6bd0976"}[chunkId] + ".chunk.css";
};